// @ts-strict-ignore
import { useMemo, useState } from 'react'

import {
	getValuesAfterPropertyChange,
	sortTradeInProperties,
	TradeInPropertySelect,
	useGetBaseCategoriesQuery,
	useGetCategoriesQuery,
	useLazyGetTradeInPriceQuery
} from '@/entities/trade-in'

import { Select } from '@/shared/ui'
import { SegmentedControl } from '@/shared/ui/segmented-control'
import { Skeletons, SkeletonType } from '@/shared/ui/Skeletons/Skeleton'

import cl from './style.module.scss'

interface TradeInDeviceProps {
	onSubmit: (price: number, info?: string) => void
}

export const TradeInForm = ({ onSubmit }: TradeInDeviceProps): JSX.Element => {
	const { data: categories } = useGetBaseCategoriesQuery()
	const [getPrice] = useLazyGetTradeInPriceQuery()
	const [activeCategory, setActiveCategory] = useState('iphone')
	const [values, setValues] = useState<{ [key: string]: string }>(null)
	const { data: detailedCategories, isLoading } = useGetCategoriesQuery({
		category: activeCategory
	})
	const sortedProperties = useMemo(
		() => (detailedCategories ? sortTradeInProperties(detailedCategories) : undefined),
		[detailedCategories]
	)
	const handleSubmit = async (currentValues: { [key: string]: string }) => {
		const payload = { LIST_SECTION_CODE: activeCategory, ...currentValues }

		const res = await getPrice(payload)

		if (res) {
			onSubmit(res.data?.PRICE, Object.values(payload).join('|'))
		}
	}
	const handleChangeOptions = (option: string) => {
		const [name, value] = option.split('=')

		const newValues = detailedCategories
			? getValuesAfterPropertyChange(detailedCategories, name, value, values)
			: { ...(values ?? {}), [name]: value }

		setValues(newValues)

		if (detailedCategories && Object.keys(newValues).length === detailedCategories.length) {
			handleSubmit(newValues)
		} else {
			onSubmit(0)
		}
	}
	const handleChangeCategories = (value: string) => {
		setActiveCategory(value)
		onSubmit(0)
		setValues(null)
	}

	if (!categories) return <Skeletons type={SkeletonType.TradeInCategories} />

	return (
		<form className={cl.form}>
			<SegmentedControl
				options={categories.map(item => ({ label: item.NAME, value: item.CODE }))}
				value={activeCategory}
				onChange={handleChangeCategories}
				className={cl.segment}
			/>
			<Select
				onChange={handleChangeCategories}
				className={cl.select__categories}
				value={activeCategory}
				options={categories.map(item => ({ label: item.NAME, value: item.CODE }))}
			/>
			<div className={cl.wrapper}>
				{sortedProperties?.map((select, index) => (
					<TradeInPropertySelect
						key={select.CODE}
						property={select}
						index={index}
						sortedProperties={sortedProperties}
						values={values}
						category={activeCategory}
						onChange={handleChangeOptions}
						className={cl.select}
					/>
				))}
			</div>

			{isLoading && <Skeletons type={SkeletonType.TradeInDevice} />}
		</form>
	)
}
